//********** C�DIGO GERADO PELO MAKECODEGENERETOR EM: 22/02/2022 01:21:27 **********
var InfraTurmaActions;
(function (InfraTurmaActions) {
    InfraTurmaActions["DELETE_TURMA"] = "DeleteTurmaInfra";
    InfraTurmaActions["DELETE_RANGE_TURMA"] = "DeleteRangeTurmaInfra";
    InfraTurmaActions["GET_TURMA"] = "GetTurmaInfra";
    InfraTurmaActions["GET_BY_ID_TURMA"] = "GetByIdTurmaInfra";
    InfraTurmaActions["GET_BY_STRING_TURMA"] = "GetByStringTurmaInfra";
    InfraTurmaActions["GET_PAGED_BY_STRING_TURMA"] = "GetPagedByStringTurmaInfra";
    InfraTurmaActions["POST_TURMA"] = "PostTurmaInfra";
    InfraTurmaActions["PUT_TURMA"] = "PutTurmaInfra";
    InfraTurmaActions["FILTER_TURMA"] = "FilterTurmaInfra";
    InfraTurmaActions["GETWITHDISABLED_TURMA"] = "GetWithDisabledTurmaInfra";
})(InfraTurmaActions || (InfraTurmaActions = {}));
//********** C�DIGO GERADO PELO MAKECODEGENERETOR EM: 22/02/2022 01:21:27 **********
var MenuActions;
(function (MenuActions) {
    MenuActions["DELETE_MENU"] = "DeleteMenu";
    MenuActions["DELETE_RANGE_MENU"] = "DeleteRangeMenu";
    MenuActions["FILTER_MENU"] = "FilterMenu";
    MenuActions["GET_MENU"] = "GetMenu";
    MenuActions["GET_ALL_MENU"] = "GetAllMenu";
    MenuActions["GET_BY_ID_MENU"] = "GetByIdMenu";
    MenuActions["GET_BY_STRING_MENU"] = "GetByStringMenu";
    MenuActions["GET_PAGED_BY_STRING_MENU"] = "GetPagedByStringMenu";
    MenuActions["POST_MENU"] = "PostMenu";
    MenuActions["PUT_MENU"] = "PutMenu";
    MenuActions["SET_MENU_ACTION"] = "SetMenuAction";
})(MenuActions || (MenuActions = {}));
//********** C�DIGO GERADO PELO MAKECODEGENERETOR EM: 08/03/2022 02:53:29 **********
var InformativoActions;
(function (InformativoActions) {
    InformativoActions["DELETE_INFORMATIVO"] = "DeleteInformativo";
    InformativoActions["DELETE_RANGE_INFORMATIVO"] = "DeleteRangeInformativo";
    InformativoActions["FILTER_INFORMATIVO"] = "FilterInformativo";
    InformativoActions["GET_INFORMATIVO"] = "GetInformativo";
    InformativoActions["GET_BY_ID_INFORMATIVO"] = "GetByIdInformativo";
    InformativoActions["GET_BY_STRING_INFORMATIVO"] = "GetByStringInformativo";
    InformativoActions["GET_PAGED_BY_STRING_INFORMATIVO"] = "GetPagedByStringInformativo";
    InformativoActions["POST_INFORMATIVO"] = "PostInformativo";
    InformativoActions["POST_BACK_INFORMATIVO"] = "PostBackInformativo";
    InformativoActions["PUT_INFORMATIVO"] = "PutInformativo";
    InformativoActions["UPLOAD_IMAGE"] = "UploadImageInformativo";
})(InformativoActions || (InformativoActions = {}));
//********** C�DIGO GERADO PELO MAKECODEGENERETOR EM: 08/03/2022 02:53:30 **********
var Informativo_MicroServicosActions;
(function (Informativo_MicroServicosActions) {
    Informativo_MicroServicosActions["DELETE_INFORMATIVO_MICROSERVICOS"] = "DeleteInformativo_MicroServicos";
    Informativo_MicroServicosActions["DELETE_RANGE_INFORMATIVO_MICROSERVICOS"] = "DeleteRangeInformativo_MicroServicos";
    Informativo_MicroServicosActions["FILTER_INFORMATIVO_MICROSERVICOS"] = "FilterInformativo_MicroServicos";
    Informativo_MicroServicosActions["GET_INFORMATIVO_MICROSERVICOS"] = "GetInformativo_MicroServicos";
    Informativo_MicroServicosActions["GET_BY_ID_INFORMATIVO_MICROSERVICOS"] = "GetByIdInformativo_MicroServicos";
    Informativo_MicroServicosActions["GET_BY_STRING_INFORMATIVO_MICROSERVICOS"] = "GetByStringInformativo_MicroServicos";
    Informativo_MicroServicosActions["GET_PAGED_BY_STRING_INFORMATIVO_MICROSERVICOS"] = "GetPagedByStringInformativo_MicroServicos";
    Informativo_MicroServicosActions["POST_INFORMATIVO_MICROSERVICOS"] = "PostInformativo_MicroServicos";
    Informativo_MicroServicosActions["PUT_INFORMATIVO_MICROSERVICOS"] = "PutInformativo_MicroServicos";
    Informativo_MicroServicosActions["POST_RANGE_INFORMATIVO_MICROSERVICOS"] = "PostRAngeInformativo_MicroServicos";
})(Informativo_MicroServicosActions || (Informativo_MicroServicosActions = {}));
//********** C�DIGO GERADO PELO MAKECODEGENERETOR EM: 08/03/2022 02:53:31 **********
var MicroServicosActions;
(function (MicroServicosActions) {
    MicroServicosActions["DELETE_MICROSERVICOS"] = "DeleteMicroServicos";
    MicroServicosActions["DELETE_RANGE_MICROSERVICOS"] = "DeleteRangeMicroServicos";
    MicroServicosActions["FILTER_MICROSERVICOS"] = "FilterMicroServicos";
    MicroServicosActions["GET_MICROSERVICOS"] = "GetMicroServicos";
    MicroServicosActions["GET_BY_ID_MICROSERVICOS"] = "GetByIdMicroServicos";
    MicroServicosActions["GET_BY_STRING_MICROSERVICOS"] = "GetByStringMicroServicos";
    MicroServicosActions["GET_PAGED_BY_STRING_MICROSERVICOS"] = "GetPagedByStringMicroServicos";
    MicroServicosActions["POST_MICROSERVICOS"] = "PostMicroServicos";
    MicroServicosActions["PUT_MICROSERVICOS"] = "PutMicroServicos";
})(MicroServicosActions || (MicroServicosActions = {}));
//********** C�DIGO GERADO PELO MAKECODEGENERETOR EM: 08/03/2022 02:53:31 **********
var TasksActions;
(function (TasksActions) {
    TasksActions["DELETE_TASKS"] = "DeleteTasks";
    TasksActions["DELETE_RANGE_TASKS"] = "DeleteRangeTasks";
    TasksActions["FILTER_TASKS"] = "FilterTasks";
    TasksActions["GET_TASKS"] = "GetTasks";
    TasksActions["GET_BY_ID_TASKS"] = "GetByIdTasks";
    TasksActions["GET_BY_STRING_TASKS"] = "GetByStringTasks";
    TasksActions["GET_PAGED_BY_STRING_TASKS"] = "GetPagedByStringTasks";
    TasksActions["POST_TASKS"] = "PostTasks";
    TasksActions["PUT_TASKS"] = "PutTasks";
    TasksActions["POST_BACK_TASKS"] = "PostBackTasks";
})(TasksActions || (TasksActions = {}));
//********** C�DIGO GERADO PELO MAKECODEGENERETOR EM: 23/03/2022 06:08:37 **********
var UsuarioActions;
(function (UsuarioActions) {
    UsuarioActions["GETUSERDATAFROMAD_USUARIO"] = "GetUserDataFromADUsuario";
    UsuarioActions["DELETE_USUARIO"] = "DeleteUsuario";
    UsuarioActions["DELETE_RANGE_USUARIO"] = "DeleteRangeUsuario";
    UsuarioActions["FILTER_USUARIO"] = "FilterUsuario";
    UsuarioActions["GET_USUARIO"] = "GetUsuario";
    UsuarioActions["GETWITHDISABLED_USUARIO"] = "GetWithDisabledUsuario";
    UsuarioActions["GET_BY_ID_USUARIO"] = "GetByIdUsuario";
    UsuarioActions["POST_USUARIO"] = "PostUsuario";
    UsuarioActions["PUT_USUARIO"] = "PutUsuario";
    UsuarioActions["POSTBACK_USUARIO"] = "PostBackUsuario";
    UsuarioActions["DELETEACESSOS_USUARIO"] = "DeleteAcessosUsuario";
    UsuarioActions["ENVIAR_EMAIL_USUARIO"] = "EnviarEmailUsuario";
    UsuarioActions["LIBERARBLOQUEIO_USUARIO"] = "LiberarBloqueioUsuario";
    UsuarioActions["GETBYCODIGOEMAIL_USUARIO"] = "GetByCodigoEmailUsuario";
    UsuarioActions["PUTDEFINIRSENHA_USUARIO"] = "PutDefinirSenhaUsuario";
    UsuarioActions["PUTBACK_USUARIO"] = "PutBackUsuario";
    UsuarioActions["ESQUECIMINHASENHA_USUARIO"] = "EsqueciMinhaSenhaUsuario";
})(UsuarioActions || (UsuarioActions = {}));
//********** C�DIGO GERADO PELO MAKECODEGENERETOR EM: 31/03/2022 10:37:34 **********
var UnidadeActions;
(function (UnidadeActions) {
    UnidadeActions["DELETE_UNIDADE"] = "DeleteUnidade";
    UnidadeActions["DELETE_RANGE_UNIDADE"] = "DeleteRangeUnidade";
    UnidadeActions["FILTER_UNIDADE"] = "FilterUnidade";
    UnidadeActions["GET_UNIDADE"] = "GetUnidade";
    UnidadeActions["GETWITHDISABLED_UNIDADE"] = "GetWithDisabledUnidade";
    UnidadeActions["GET_BY_ID_UNIDADE"] = "GetByIdUnidade";
    UnidadeActions["POST_UNIDADE"] = "PostUnidade";
    UnidadeActions["PUT_UNIDADE"] = "PutUnidade";
})(UnidadeActions || (UnidadeActions = {}));
//********** C�DIGO GERADO PELO MAKECODEGENERETOR EM: 31/03/2022 10:51:15 **********
var RoleActions;
(function (RoleActions) {
    RoleActions["DELETE_ROLE"] = "DeleteRole";
    RoleActions["DELETE_RANGE_ROLE"] = "DeleteRangeRole";
    RoleActions["FILTER_ROLE"] = "FilterRole";
    RoleActions["GET_ROLE"] = "GetRole";
    RoleActions["GETWITHDISABLED_ROLE"] = "GetWithDisabledRole";
    RoleActions["GET_BY_ID_ROLE"] = "GetByIdRole";
    RoleActions["POST_ROLE"] = "PostRole";
    RoleActions["PUT_ROLE"] = "PutRole";
})(RoleActions || (RoleActions = {}));
//********** C�DIGO GERADO PELO MAKECODEGENERETOR EM: 31/03/2022 10:51:15 **********
var Usuario_UnidadeActions;
(function (Usuario_UnidadeActions) {
    Usuario_UnidadeActions["DELETE_USUARIO_UNIDADE"] = "DeleteUsuario_Unidade";
    Usuario_UnidadeActions["DELETE_RANGE_USUARIO_UNIDADE"] = "DeleteRangeUsuario_Unidade";
    Usuario_UnidadeActions["FILTER_USUARIO_UNIDADE"] = "FilterUsuario_Unidade";
    Usuario_UnidadeActions["GET_USUARIO_UNIDADE"] = "GetUsuario_Unidade";
    Usuario_UnidadeActions["GETWITHDISABLED_USUARIO_UNIDADE"] = "GetWithDisabledUsuario_Unidade";
    Usuario_UnidadeActions["GET_BY_ID_USUARIO_UNIDADE"] = "GetByIdUsuario_Unidade";
    Usuario_UnidadeActions["POST_USUARIO_UNIDADE"] = "PostUsuario_Unidade";
    Usuario_UnidadeActions["PUT_USUARIO_UNIDADE"] = "PutUsuario_Unidade";
    Usuario_UnidadeActions["POSTRANGEBACK_USUARIO_UNIDADE"] = "PostRangeBackUsuario_Unidade";
    Usuario_UnidadeActions["GET_BY_USUARIO_ID_USUARIO_UNIDADE"] = "GetByUsuarioIdUsuario_Unidade";
    Usuario_UnidadeActions["GET_UNIDADE_BY_USUARIO_ID"] = "GetUnidadeByUsuarioIdUsuario_Unidade";
    Usuario_UnidadeActions["GETUNITBYUSER_USUARIO_UNIDADE"] = "GetUnitByUserUsuario_Unidade";
})(Usuario_UnidadeActions || (Usuario_UnidadeActions = {}));
//********** C�DIGO GERADO PELO MAKECODEGENERETOR EM: 31/03/2022 10:51:15 **********
var Usuario_Unidade_RoleActions;
(function (Usuario_Unidade_RoleActions) {
    Usuario_Unidade_RoleActions["DELETE_USUARIO_UNIDADE_ROLE"] = "DeleteUsuario_Unidade_Role";
    Usuario_Unidade_RoleActions["DELETE_RANGE_USUARIO_UNIDADE_ROLE"] = "DeleteRangeUsuario_Unidade_Role";
    Usuario_Unidade_RoleActions["FILTER_USUARIO_UNIDADE_ROLE"] = "FilterUsuario_Unidade_Role";
    Usuario_Unidade_RoleActions["GET_USUARIO_UNIDADE_ROLE"] = "GetUsuario_Unidade_Role";
    Usuario_Unidade_RoleActions["GETWITHDISABLED_USUARIO_UNIDADE_ROLE"] = "GetWithDisabledUsuario_Unidade_Role";
    Usuario_Unidade_RoleActions["GET_BY_ID_USUARIO_UNIDADE_ROLE"] = "GetByIdUsuario_Unidade_Role";
    Usuario_Unidade_RoleActions["POST_USUARIO_UNIDADE_ROLE"] = "PostUsuario_Unidade_Role";
    Usuario_Unidade_RoleActions["PUT_USUARIO_UNIDADE_ROLE"] = "PutUsuario_Unidade_Role";
    Usuario_Unidade_RoleActions["POSTRANGE_USUARIO_UNIDADE_ROLE"] = "PostRangeUsuario_Unidade_Role";
})(Usuario_Unidade_RoleActions || (Usuario_Unidade_RoleActions = {}));
//********** C�DIGO GERADO PELO MAKECODEGENERETOR EM: 04/04/2022 10:56:30 **********
var AmostragemActions;
(function (AmostragemActions) {
    AmostragemActions["DELETE_AMOSTRAGEM"] = "DeleteAmostragem";
    AmostragemActions["DELETE_RANGE_AMOSTRAGEM"] = "DeleteRangeAmostragem";
    AmostragemActions["FILTER_AMOSTRAGEM"] = "FilterAmostragem";
    AmostragemActions["GET_AMOSTRAGEM"] = "GetAmostragem";
    AmostragemActions["GETWITHDISABLED_AMOSTRAGEM"] = "GetWithDisabledAmostragem";
    AmostragemActions["GET_BY_ID_AMOSTRAGEM"] = "GetByIdAmostragem";
    AmostragemActions["POST_AMOSTRAGEM"] = "PostAmostragem";
    AmostragemActions["PUT_AMOSTRAGEM"] = "PutAmostragem";
})(AmostragemActions || (AmostragemActions = {}));
//********** C�DIGO GERADO PELO MAKECODEGENERETOR EM: 04/04/2022 03:30:58 **********
var DesmonteActions;
(function (DesmonteActions) {
    DesmonteActions["DELETE_DESMONTE"] = "DeleteDesmonte";
    DesmonteActions["DELETE_RANGE_DESMONTE"] = "DeleteRangeDesmonte";
    DesmonteActions["FILTER_DESMONTE"] = "FilterDesmonte";
    DesmonteActions["GET_DESMONTE"] = "GetDesmonte";
    DesmonteActions["GETWITHDISABLED_DESMONTE"] = "GetWithDisabledDesmonte";
    DesmonteActions["GET_BY_ID_DESMONTE"] = "GetByIdDesmonte";
    DesmonteActions["POST_DESMONTE"] = "PostDesmonte";
    DesmonteActions["PUT_DESMONTE"] = "PutDesmonte";
})(DesmonteActions || (DesmonteActions = {}));
//********** C�DIGO GERADO PELO MAKECODEGENERETOR EM: 11/04/2022 02:28:50 **********
var Agenda_Manutencao_EquipamentoActions;
(function (Agenda_Manutencao_EquipamentoActions) {
    Agenda_Manutencao_EquipamentoActions["DELETE_AGENDA_MANUTENCAO_EQUIPAMENTO"] = "DeleteAgenda_Manutencao_Equipamento";
    Agenda_Manutencao_EquipamentoActions["DELETE_RANGE_AGENDA_MANUTENCAO_EQUIPAMENTO"] = "DeleteRangeAgenda_Manutencao_Equipamento";
    Agenda_Manutencao_EquipamentoActions["FILTER_AGENDA_MANUTENCAO_EQUIPAMENTO"] = "FilterAgenda_Manutencao_Equipamento";
    Agenda_Manutencao_EquipamentoActions["GET_AGENDA_MANUTENCAO_EQUIPAMENTO"] = "GetAgenda_Manutencao_Equipamento";
    Agenda_Manutencao_EquipamentoActions["GETWITHDISABLED_AGENDA_MANUTENCAO_EQUIPAMENTO"] = "GetWithDisabledAgenda_Manutencao_Equipamento";
    Agenda_Manutencao_EquipamentoActions["GET_BY_ID_AGENDA_MANUTENCAO_EQUIPAMENTO"] = "GetByIdAgenda_Manutencao_Equipamento";
    Agenda_Manutencao_EquipamentoActions["POST_AGENDA_MANUTENCAO_EQUIPAMENTO"] = "PostAgenda_Manutencao_Equipamento";
    Agenda_Manutencao_EquipamentoActions["PUT_AGENDA_MANUTENCAO_EQUIPAMENTO"] = "PutAgenda_Manutencao_Equipamento";
})(Agenda_Manutencao_EquipamentoActions || (Agenda_Manutencao_EquipamentoActions = {}));
//********** C�DIGO GERADO PELO MAKECODEGENERETOR EM: 12/04/2022 09:36:56 **********
var Agenda_Manutencao_StatusActions;
(function (Agenda_Manutencao_StatusActions) {
    Agenda_Manutencao_StatusActions["DELETE_AGENDA_MANUTENCAO_STATUS"] = "DeleteAgenda_Manutencao_Status";
    Agenda_Manutencao_StatusActions["DELETE_RANGE_AGENDA_MANUTENCAO_STATUS"] = "DeleteRangeAgenda_Manutencao_Status";
    Agenda_Manutencao_StatusActions["FILTER_AGENDA_MANUTENCAO_STATUS"] = "FilterAgenda_Manutencao_Status";
    Agenda_Manutencao_StatusActions["GET_AGENDA_MANUTENCAO_STATUS"] = "GetAgenda_Manutencao_Status";
    Agenda_Manutencao_StatusActions["GETWITHDISABLED_AGENDA_MANUTENCAO_STATUS"] = "GetWithDisabledAgenda_Manutencao_Status";
    Agenda_Manutencao_StatusActions["GET_BY_ID_AGENDA_MANUTENCAO_STATUS"] = "GetByIdAgenda_Manutencao_Status";
    Agenda_Manutencao_StatusActions["POST_AGENDA_MANUTENCAO_STATUS"] = "PostAgenda_Manutencao_Status";
    Agenda_Manutencao_StatusActions["PUT_AGENDA_MANUTENCAO_STATUS"] = "PutAgenda_Manutencao_Status";
})(Agenda_Manutencao_StatusActions || (Agenda_Manutencao_StatusActions = {}));
//********** C�DIGO GERADO PELO MAKECODEGENERETOR EM: 08/04/2022 03:35:30 **********
var EmpresaActions;
(function (EmpresaActions) {
    EmpresaActions["DELETE_EMPRESA"] = "DeleteEmpresa";
    EmpresaActions["DELETE_RANGE_EMPRESA"] = "DeleteRangeEmpresa";
    EmpresaActions["FILTER_EMPRESA"] = "FilterEmpresa";
    EmpresaActions["GET_EMPRESA"] = "GetEmpresa";
    EmpresaActions["GETWITHDISABLED_EMPRESA"] = "GetWithDisabledEmpresa";
    EmpresaActions["GET_BY_ID_EMPRESA"] = "GetByIdEmpresa";
    EmpresaActions["POST_EMPRESA"] = "PostEmpresa";
    EmpresaActions["PUT_EMPRESA"] = "PutEmpresa";
})(EmpresaActions || (EmpresaActions = {}));
//********** C�DIGO GERADO PELO MAKECODEGENERETOR EM: 31/05/2022 03:50:29 **********
var EstadoActions;
(function (EstadoActions) {
    EstadoActions["DELETE_ESTADO"] = "DeleteEstado";
    EstadoActions["DELETE_RANGE_ESTADO"] = "DeleteRangeEstado";
    EstadoActions["FILTER_ESTADO"] = "FilterEstado";
    EstadoActions["GET_ESTADO"] = "GetEstado";
    EstadoActions["GETWITHDISABLED_ESTADO"] = "GetWithDisabledEstado";
    EstadoActions["GET_BY_ID_ESTADO"] = "GetByIdEstado";
    EstadoActions["POST_ESTADO"] = "PostEstado";
    EstadoActions["PUT_ESTADO"] = "PutEstado";
})(EstadoActions || (EstadoActions = {}));
//********** C�DIGO GERADO PELO MAKECODEGENERETOR EM: 31/05/2022 03:50:30 **********
var Fuso_HorarioActions;
(function (Fuso_HorarioActions) {
    Fuso_HorarioActions["DELETE_FUSO_HORARIO"] = "DeleteFuso_Horario";
    Fuso_HorarioActions["DELETE_RANGE_FUSO_HORARIO"] = "DeleteRangeFuso_Horario";
    Fuso_HorarioActions["FILTER_FUSO_HORARIO"] = "FilterFuso_Horario";
    Fuso_HorarioActions["GET_FUSO_HORARIO"] = "GetFuso_Horario";
    Fuso_HorarioActions["GETWITHDISABLED_FUSO_HORARIO"] = "GetWithDisabledFuso_Horario";
    Fuso_HorarioActions["GET_BY_ID_FUSO_HORARIO"] = "GetByIdFuso_Horario";
    Fuso_HorarioActions["POST_FUSO_HORARIO"] = "PostFuso_Horario";
    Fuso_HorarioActions["PUT_FUSO_HORARIO"] = "PutFuso_Horario";
})(Fuso_HorarioActions || (Fuso_HorarioActions = {}));
//********** C�DIGO GERADO PELO MAKECODEGENERETOR EM: 31/05/2022 03:50:30 **********
var PaisActions;
(function (PaisActions) {
    PaisActions["DELETE_PAIS"] = "DeletePais";
    PaisActions["DELETE_RANGE_PAIS"] = "DeleteRangePais";
    PaisActions["FILTER_PAIS"] = "FilterPais";
    PaisActions["GET_PAIS"] = "GetPais";
    PaisActions["GETWITHDISABLED_PAIS"] = "GetWithDisabledPais";
    PaisActions["GET_BY_ID_PAIS"] = "GetByIdPais";
    PaisActions["POST_PAIS"] = "PostPais";
    PaisActions["PUT_PAIS"] = "PutPais";
})(PaisActions || (PaisActions = {}));
//********** C�DIGO GERADO PELO MAKECODEGENERETOR EM: 31/05/2022 03:50:30 **********
var RegiaoActions;
(function (RegiaoActions) {
    RegiaoActions["DELETE_REGIAO"] = "DeleteRegiao";
    RegiaoActions["DELETE_RANGE_REGIAO"] = "DeleteRangeRegiao";
    RegiaoActions["FILTER_REGIAO"] = "FilterRegiao";
    RegiaoActions["GET_REGIAO"] = "GetRegiao";
    RegiaoActions["GETWITHDISABLED_REGIAO"] = "GetWithDisabledRegiao";
    RegiaoActions["GET_BY_ID_REGIAO"] = "GetByIdRegiao";
    RegiaoActions["POST_REGIAO"] = "PostRegiao";
    RegiaoActions["PUT_REGIAO"] = "PutRegiao";
})(RegiaoActions || (RegiaoActions = {}));
//********** C�DIGO GERADO PELO MAKECODEGENERETOR EM: 31/05/2022 03:50:30 **********
var Informativo_UnidadeActions;
(function (Informativo_UnidadeActions) {
    Informativo_UnidadeActions["DELETE_INFORMATIVO_UNIDADE"] = "DeleteInformativo_Unidade";
    Informativo_UnidadeActions["DELETE_RANGE_INFORMATIVO_UNIDADE"] = "DeleteRangeInformativo_Unidade";
    Informativo_UnidadeActions["FILTER_INFORMATIVO_UNIDADE"] = "FilterInformativo_Unidade";
    Informativo_UnidadeActions["GET_INFORMATIVO_UNIDADE"] = "GetInformativo_Unidade";
    Informativo_UnidadeActions["GETWITHDISABLED_INFORMATIVO_UNIDADE"] = "GetWithDisabledInformativo_Unidade";
    Informativo_UnidadeActions["GET_BY_ID_INFORMATIVO_UNIDADE"] = "GetByIdInformativo_Unidade";
    Informativo_UnidadeActions["POST_INFORMATIVO_UNIDADE"] = "PostInformativo_Unidade";
    Informativo_UnidadeActions["PUT_INFORMATIVO_UNIDADE"] = "PutInformativo_Unidade";
    Informativo_UnidadeActions["POST_RANGE_INFORMATIVO_UNIDADE"] = "PostRangeInformativo_Unidade";
})(Informativo_UnidadeActions || (Informativo_UnidadeActions = {}));
//********** C�DIGO GERADO PELO MAKECODEGENERETOR EM: 19/06/2022 10:34:37 **********
var Tipo_InformativoActions;
(function (Tipo_InformativoActions) {
    Tipo_InformativoActions["DELETE_TIPO_INFORMATIVO"] = "DeleteTipo_Informativo";
    Tipo_InformativoActions["DELETE_RANGE_TIPO_INFORMATIVO"] = "DeleteRangeTipo_Informativo";
    Tipo_InformativoActions["FILTER_TIPO_INFORMATIVO"] = "FilterTipo_Informativo";
    Tipo_InformativoActions["GET_TIPO_INFORMATIVO"] = "GetTipo_Informativo";
    Tipo_InformativoActions["GETWITHDISABLED_TIPO_INFORMATIVO"] = "GetWithDisabledTipo_Informativo";
    Tipo_InformativoActions["GET_BY_ID_TIPO_INFORMATIVO"] = "GetByIdTipo_Informativo";
    Tipo_InformativoActions["POST_TIPO_INFORMATIVO"] = "PostTipo_Informativo";
    Tipo_InformativoActions["PUT_TIPO_INFORMATIVO"] = "PutTipo_Informativo";
})(Tipo_InformativoActions || (Tipo_InformativoActions = {}));
var Tipo_AutenticacaoActions;
(function (Tipo_AutenticacaoActions) {
    Tipo_AutenticacaoActions["DELETE_TIPO_AUTENTICACAO"] = "DeleteTipo_Autenticacao";
    Tipo_AutenticacaoActions["DELETE_RANGE_TIPO_AUTENTICACAO"] = "DeleteRangeTipo_Autenticacao";
    Tipo_AutenticacaoActions["FILTER_TIPO_AUTENTICACAO"] = "FilterTipo_Autenticacao";
    Tipo_AutenticacaoActions["GET_TIPO_AUTENTICACAO"] = "GetTipo_Autenticacao";
    Tipo_AutenticacaoActions["GETWITHDISABLED_TIPO_AUTENTICACAO"] = "GetWithDisabledTipo_Autenticacao";
    Tipo_AutenticacaoActions["GET_BY_ID_TIPO_AUTENTICACAO"] = "GetByIdTipo_Autenticacao";
    Tipo_AutenticacaoActions["POST_TIPO_AUTENTICACAO"] = "PostTipo_Autenticacao";
    Tipo_AutenticacaoActions["PUT_TIPO_AUTENTICACAO"] = "PutTipo_Autenticacao";
})(Tipo_AutenticacaoActions || (Tipo_AutenticacaoActions = {}));
var RotasActions;
(function (RotasActions) {
    RotasActions["RECUPERAR_DISTRITOS"] = "Recuperar_Distritos";
    RotasActions["OBTER_DISTANCIA"] = "Obter_Distancia";
})(RotasActions || (RotasActions = {}));
export { 
//********** C�DIGO GERADO PELO MAKECODEGENERETOR EM: 22/02/2022 01:21:27 **********
InfraTurmaActions, 
//********** C�DIGO GERADO PELO MAKECODEGENERETOR EM: 22/02/2022 01:21:27 **********
MenuActions, 
//********** C�DIGO GERADO PELO MAKECODEGENERETOR EM: 08/03/2022 02:53:29 **********
InformativoActions, 
//********** C�DIGO GERADO PELO MAKECODEGENERETOR EM: 08/03/2022 02:53:30 **********
Informativo_MicroServicosActions, 
//********** C�DIGO GERADO PELO MAKECODEGENERETOR EM: 08/03/2022 02:53:31 **********
MicroServicosActions, 
//********** C�DIGO GERADO PELO MAKECODEGENERETOR EM: 08/03/2022 02:53:31 **********
TasksActions, 
//********** C�DIGO GERADO PELO MAKECODEGENERETOR EM: 23/03/2022 06:08:37 **********
UsuarioActions, 
//********** C�DIGO GERADO PELO MAKECODEGENERETOR EM: 04/04/2022 10:56:30 **********
AmostragemActions, 
//********** C�DIGO GERADO PELO MAKECODEGENERETOR EM: 08/04/2022 03:35:30 **********
EmpresaActions, 
//********** C�DIGO GERADO PELO MAKECODEGENERETOR EM: 04/04/2022 03:30:58 **********
DesmonteActions, 
//********** C�DIGO GERADO PELO MAKECODEGENERETOR EM: 31/03/2022 10:37:34 **********
UnidadeActions, 
//********** C�DIGO GERADO PELO MAKECODEGENERETOR EM: 31/03/2022 10:51:15 **********
RoleActions, 
//********** C�DIGO GERADO PELO MAKECODEGENERETOR EM: 31/03/2022 10:51:15 **********
Usuario_UnidadeActions, 
//********** C�DIGO GERADO PELO MAKECODEGENERETOR EM: 31/03/2022 10:51:15 **********
Usuario_Unidade_RoleActions, 
//********** C�DIGO GERADO PELO MAKECODEGENERETOR EM: 11/04/2022 02:28:50 **********
Agenda_Manutencao_EquipamentoActions, 
//********** C�DIGO GERADO PELO MAKECODEGENERETOR EM: 12/04/2022 09:36:56 **********
Agenda_Manutencao_StatusActions, 
//********** C�DIGO GERADO PELO MAKECODEGENERETOR EM: 31/05/2022 03:50:29 **********
EstadoActions, 
//********** C�DIGO GERADO PELO MAKECODEGENERETOR EM: 31/05/2022 03:50:30 **********
Fuso_HorarioActions, 
//********** C�DIGO GERADO PELO MAKECODEGENERETOR EM: 31/05/2022 03:50:30 **********
PaisActions, 
//********** C�DIGO GERADO PELO MAKECODEGENERETOR EM: 31/05/2022 03:50:30 **********
RegiaoActions, 
//********** C�DIGO GERADO PELO MAKECODEGENERETOR EM: 10/06/2022 03:19:16 **********
Informativo_UnidadeActions, 
//********** C�DIGO GERADO PELO MAKECODEGENERETOR EM: 19/06/2022 10:34:37 **********
Tipo_InformativoActions, Tipo_AutenticacaoActions, RotasActions, };
//# sourceMappingURL=InfraEnums.js.map